var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view', {
    directives: [{
      name: "loading",
      rawName: "v-loading"
    }],
    on: {
      "hook:beforeCreate": _vm.pageBeforeCreate,
      "hook:mounted": _vm.pageMounted,
      "hook:activated": _vm.pageMounted,
      "hook:beforeDestroy": _vm.adReachDestroy,
      "hook:deactivated": _vm.adReachDestroy
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };
const __FLY_DATA_ = {};